<template>
  <div v-if="savedSearches && savedSearches.length > 0">
    <dropdown-select
      :labelText="$tc('SAVED_VIEW', 1)"
      :items="savedSearches"
      :initialSelection="selectedSearch"
      :multipleInitialSelections="true"
      :emitInitialSelection="true"
      @selected="selectSearch"
    />

    <div class="field">
      <label for="count">{{ $t('COUNT', { thing: $tc('ENTRY', 2) }) }}</label>
      <input id="count" type="number" :placeholder="10" v-model.number="c" />
    </div>
  </div>
  <div v-else>
    <div class="ui visible warning message">
      <i class="meh icon" />
      <span v-html="$t('NO_SAVED_SEARCHES')" />
    </div>
  </div>
</template>

<script>
// @flow
import Vue from 'vue'
import { DropdownSelect } from 'ui'
import { Flow } from 'services'

export default {
  name: 'flows-landing-page-options',

  components: { DropdownSelect },

  props: {
    perPage: {
      type: Number,
      default: () => 10
    },
    selectedSearch: {
      type: String,
      default: () => ''
    }
  },

  data() {
    return {
      c: this.perPage,
      s: this.selectedSearch,
      savedSearches: []
    }
  },

  methods: {
    selectSearch(s) {
      this.s = s.id
      this.$emit('update', { perPage: this.c || 10, selectedSearch: this.s, mode: 'mini' })
    }
  },

  mounted() {
    Flow.getSearches().then(searches => (this.savedSearches = searches))
  },

  watch: {
    c(newCount) {
      this.$emit('update', { perPage: newCount || 10, selectedSearch: this.s, mode: 'mini' })
    }
  }
}
</script>
